import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _instanceof } from "@swc/helpers/_/_instanceof";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import * as datalistActions from "../../slices/report/getReportProductNotReadyDeliveryDatalist.slice";
import * as widgetActions from "../../slices/report/getReportProductNotReadyDeliveryWidget.slice";
import { http } from "utils/http";
import { endPoint } from "constants/server/api";
export var getReportProductNotReadyDeliveryDatalist = function(payload, param) {
    var modalObj = param.modalObj, setModalObj = param.setModalObj;
    return function() {
        var _ref = _async_to_generator(function(dispatch) {
            var accessToken, config, result, error, statusCode;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dispatch(datalistActions.fetchData());
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        accessToken = localStorage.getItem("accessToken");
                        config = {
                            method: "post",
                            headers: {
                                Authorization: "Bearer ".concat(accessToken)
                            },
                            url: endPoint.REPORT_PRODUCT_NOT_READY_DELIVERY_DATALIST,
                            data: payload
                        };
                        return [
                            4,
                            http(config)
                        ];
                    case 2:
                        result = _state.sent();
                        dispatch(datalistActions.fetchDataSuccess(result.data));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        if (http.isAxiosError(error) && error.response) {
                            statusCode = error.response.status;
                            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                                visible: true,
                                subTitle: "รหัส ".concat(statusCode),
                                navigateDirection: undefined,
                                title: "".concat(error.response.data.message)
                            }));
                        } else {
                            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                                visible: true,
                                subTitle: "รหัส 500",
                                navigateDirection: undefined,
                                title: "เกิดข้อผิดพลาด\nหรือเครือข่ายขัดข้อง"
                            }));
                        }
                        dispatch(datalistActions.fetchDataFailure());
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
export var getReportProductNotReadyDeliveryWidget = function(payload, param) {
    var modalObj = param.modalObj, setModalObj = param.setModalObj;
    return function() {
        var _ref = _async_to_generator(function(dispatch) {
            var accessToken, config, result, error, statusCode;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dispatch(widgetActions.fetchData());
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        accessToken = localStorage.getItem("accessToken");
                        config = {
                            method: "post",
                            headers: {
                                Authorization: "Bearer ".concat(accessToken)
                            },
                            url: endPoint.REPORT_PRODUCT_NOT_READY_DELIVERY_WIDGET,
                            data: payload
                        };
                        return [
                            4,
                            http(config)
                        ];
                    case 2:
                        result = _state.sent();
                        dispatch(widgetActions.fetchDataSuccess(result.data));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        if (http.isAxiosError(error) && error.response) {
                            statusCode = error.response.status;
                            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                                visible: true,
                                subTitle: "รหัส ".concat(statusCode),
                                navigateDirection: undefined,
                                title: "".concat(error.response.data.message)
                            }));
                        } else {
                            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                                visible: true,
                                subTitle: "รหัส 500",
                                navigateDirection: undefined,
                                title: "เกิดข้อผิดพลาด\nหรือเครือข่ายขัดข้อง"
                            }));
                        }
                        dispatch(widgetActions.fetchDataFailure());
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var getDownloadFileName = function(contentDisposition) {
    if (!contentDisposition) return "report_product_not_ready_delivery.xlsx";
    var utf8FileName = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8FileName === null || utf8FileName === void 0 ? void 0 : utf8FileName[1]) return decodeURIComponent(utf8FileName[1]);
    var fileName = contentDisposition.match(/filename="?([^";]+)"?/i);
    return (fileName === null || fileName === void 0 ? void 0 : fileName[1]) || "report_product_not_ready_delivery.xlsx";
};
export var exportReportProductNotReadyDelivery = function(payload, param) {
    var modalObj = param.modalObj, setModalObj = param.setModalObj;
    return /*#__PURE__*/ _async_to_generator(function() {
        var _result_headers, _result_headers1, accessToken, config, result, contentType, blob, downloadUrl, link, error, statusCode;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    accessToken = localStorage.getItem("accessToken");
                    config = {
                        method: "post",
                        headers: {
                            Authorization: "Bearer ".concat(accessToken)
                        },
                        url: endPoint.REPORT_PRODUCT_NOT_READY_DELIVERY_EXPORT_EXCEL,
                        data: payload,
                        responseType: "blob"
                    };
                    return [
                        4,
                        http(config)
                    ];
                case 1:
                    result = _state.sent();
                    contentType = ((_result_headers = result.headers) === null || _result_headers === void 0 ? void 0 : _result_headers["content-type"]) || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                    blob = _instanceof(result.data, Blob) ? result.data : new Blob([
                        result.data
                    ], {
                        type: contentType
                    });
                    downloadUrl = window.URL.createObjectURL(blob);
                    link = document.createElement("a");
                    link.href = downloadUrl;
                    link.download = getDownloadFileName((_result_headers1 = result.headers) === null || _result_headers1 === void 0 ? void 0 : _result_headers1["content-disposition"]);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(downloadUrl);
                    return [
                        2,
                        true
                    ];
                case 2:
                    error = _state.sent();
                    if (http.isAxiosError(error) && error.response) {
                        statusCode = error.response.status;
                        setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                            visible: true,
                            subTitle: "รหัส ".concat(statusCode),
                            navigateDirection: undefined,
                            title: "".concat(error.response.data.message)
                        }));
                    } else {
                        setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                            visible: true,
                            subTitle: "รหัส 500",
                            navigateDirection: undefined,
                            title: "เกิดข้อผิดพลาด\nหรือเครือข่ายขัดข้อง"
                        }));
                    }
                    return [
                        2,
                        false
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
};
export var clearReportProductNotReadyDelivery = function() {
    return function() {
        var _ref = _async_to_generator(function(dispatch) {
            return _ts_generator(this, function(_state) {
                dispatch(datalistActions.resetState());
                dispatch(widgetActions.resetState());
                return [
                    2
                ];
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
